import { useSelector} from 'react-redux'
import {selectBasketProducts} from '../../store/basket/selectors'

export const useGenerateTable = () => {
  const basketProducts = useSelector(selectBasketProducts)

  return {
    isEmptyBasket: !basketProducts.length,
  }
}